import React, { SVGAttributes } from 'react'

interface SkitLogoProps extends SVGAttributes<SVGElement> {
  rounded?: boolean
}

export const SkitLogo: React.FC<SkitLogoProps> = ({ width = 20, height = 20, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 24 24`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.997 10.147c-.013-.92-.075-1.833-.304-2.73C18.66 3.406 15.023.415 10.85.038a10.013 10.013 0 0 0-3.98.454C2.618 1.869-.253 6.043.019 10.449c.25 4.034 3.11 7.62 7.03 8.81 1.855.557 3.834.578 5.7.06.983-.273 1.949-.653 2.975-.736 1.053-.084 2.13.158 3.071.628A6.13 6.13 0 0 1 20 20v-9.36c0-.164-.001-.329-.003-.493Zm-2.86-.082c-.74.143-1.334.8-1.7 1.41-.367.611-.584 1.29-.8 1.965l-.54 1.683c-.163.509-.269 1.134-.558 1.589a.79.79 0 0 1-.77.354c-.449-.066-.63-.5-.74-.881-.403-1.387-.713-2.306-1.133-3.687-.09-.297-.338-1.139-.577-1.365a.467.467 0 0 0-.35-.129.565.565 0 0 0-.375.216c-.139.168-.227.389-.335.577-.199.35-.638.663-1.052.477-.428-.193-.561-.778-.862-1.107A.686.686 0 0 0 7.13 11c-.341-.155-.674.228-.862.456-.304.367-.543.858-.987 1.082-.569.286-1.045-.309-1.31-.732-.157-.25-.292-.51-.462-.752-.267-.38-.75-.905-1.231-1.008a.985.985 0 0 0-.215-.023.946.946 0 0 0 .214-.024c.46-.102.846-.544 1.126-.893.328-.407.6-.854.927-1.261.173-.214.4-.434.678-.423.178.007.337.11.47.227.278.245.479.557.71.84.191.234.492.617.837.58.401-.043.579-.58.757-.869.155-.25.388-.49.686-.504.297-.014.557.208.724.453.189.28.338.782.692.9.388.129.624-.292.744-.579.426-1.012.719-2.072 1.01-3.13l.374-1.348c.108-.39.253-.87.706-.979a.74.74 0 0 1 .558.09c.203.127.33.35.411.572.351.968.625 1.974.938 2.955.222.697.448 1.401.839 2.022.468.743 1.199 1.369 2.121 1.369-.15 0-.301.016-.449.045Z"
        fill={props?.fill ?? 'url(#a)'}
      />
      <defs>
        <linearGradient
          id="a"
          x1={5.823}
          y1={18.584}
          x2={17.511}
          y2={3.238}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#114C90" />
          <stop offset={0.31} stopColor="#0D8ADB" />
          <stop offset={0.6} stopColor="#35C1F1" />
          <stop offset={1} stopColor="#66EB6E" />
        </linearGradient>
      </defs>
    </svg>
  )
}
